import {useEffect, useRef} from 'react'
import {useScrollLock} from '@app/hooks/use-scroll-lock'

interface Props {
  onDialogOpen: () => void
  onDialogClose?: () => void
}
const useCCPADialogWatch = ({onDialogClose, onDialogOpen}: Props) => {
  const openRefTimer = useRef<NodeJS.Timeout>(null)
  const closeRefTimer = useRef<NodeJS.Timeout>(null)
  const {lockScroll, unlockScroll} = useScrollLock()

  useEffect(() => {
    return () => {
      if (openRefTimer.current) clearInterval(openRefTimer.current)
      if (closeRefTimer.current) clearInterval(closeRefTimer.current)
    }
  }, [])

  function getPopupContainer() {
    return document.getElementById('qc-cmp2-usp')
  }

  function listenToDialogClose() {
    closeRefTimer.current = setInterval(() => {
      if (!getPopupContainer()) {
        if (openRefTimer.current) {
          clearInterval(openRefTimer.current)
        }
        unlockScroll()
        onDialogClose && onDialogClose()
        listenToDialogClose()
      }
    }, 700)
  }

  function listenToDialogOpen() {
    openRefTimer.current = setInterval(() => {
      if (getPopupContainer()) {
        if (openRefTimer.current) {
          clearInterval(openRefTimer.current)
        }
        lockScroll()
        onDialogOpen()
        listenToDialogClose()
      }
    }, 700)
  }

  return listenToDialogOpen
}

export default useCCPADialogWatch
